import bgAssets from '../../../../client/src/assets/bg.json';
import enemyAssets from '../../../../client/src/assets/enemy.json';
import characterAssets from '../../../../client/src/assets/character.json';
import iconAssets from '../../../../client/src/assets/icons.json';
import imageAssets from '../../../../client/src/assets/images.json';
import effectAssets from '../../../../client/src/assets/effects.json';
import objectAssets from '../../../../client/src/assets/objects.json';
import audioAssets from '../../../../client/src/assets/audio.json';

export type AssetSource =
  | 'bg'
  | 'enemy'
  | 'character'
  | 'icons'
  | 'images'
  | 'effects'
  | 'objects'
  | 'audio';

export interface AssetEntry {
  url: string;
  description?: string;
  metadata?: { width?: number; height?: number; type?: string; originalName?: string };
}

type RegistryNode = AssetEntry | Record<string, AssetEntry>;

export const ASSET_REGISTRIES: Record<AssetSource, Record<string, RegistryNode>> = {
  bg: bgAssets as unknown as Record<string, AssetEntry>,
  enemy: enemyAssets as unknown as Record<string, AssetEntry>,
  character: characterAssets as unknown as Record<string, AssetEntry>,
  icons: iconAssets as unknown as Record<string, RegistryNode>,
  images: imageAssets as unknown as Record<string, AssetEntry>,
  effects: effectAssets as unknown as Record<string, AssetEntry>,
  objects: objectAssets as unknown as Record<string, AssetEntry>,
  audio: audioAssets as unknown as Record<string, AssetEntry>,
};

/** walks possibly-nested registry and returns the entry whose key matches */
export function lookupAsset(source: AssetSource, key: string): AssetEntry | null {
  const reg = ASSET_REGISTRIES[source];
  const direct = reg[key];
  if (direct && 'url' in direct) return direct as AssetEntry;
  // depth-1 nested lookup (icons.json: { currency: { emerald: {...} } })
  for (const v of Object.values(reg)) {
    if (typeof v === 'object' && v !== null && !('url' in v)) {
      const nested = (v as Record<string, AssetEntry>)[key];
      if (nested && 'url' in nested) return nested;
    }
  }
  return null;
}
